/** Vendor BOM error when a field has only E or W half-panels (UUID in message is dynamic). */
const VDV_HALF_PANELS_EW_ONLY_PATTERN =
  /Panel field '[^']+' cannot contain only half panels \(E or W\)\.?/i

/**
 * Map VanderValk vendor BOM API messages to user-facing mounting-tab copy.
 * Returns the original message when no mapping applies.
 */
export function mapVanDerValkBomApiErrorToUserMessage(rawMessage: string | undefined | null): string | undefined {
  const trimmed = rawMessage?.trim()
  if (!trimmed) {
    return undefined
  }

  if (VDV_HALF_PANELS_EW_ONLY_PATTERN.test(trimmed)) {
    return (
      window.translate?.('mount_vdv_half_panels_ew_only') ??
      'Panels cannot be in just East or West, they must be both'
    )
  }

  return trimmed
}
